import { render, staticRenderFns } from "./TrainingCard.vue?vue&type=template&id=5f75536f&scoped=true&lang=pug&"
import script from "./TrainingCard.vue?vue&type=script&lang=ts&"
export * from "./TrainingCard.vue?vue&type=script&lang=ts&"
import style0 from "./TrainingCard.vue?vue&type=style&index=0&id=5f75536f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f75536f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
